import { SUPPORTED_LANGUAGES } from '../renderer/store/hub/types';

export const getLanguage = (preferredLanguage: SUPPORTED_LANGUAGES, defaultLanguage: string) => {
  const re = /\w+/g;
  const [languageCode] = defaultLanguage.match(re) || [];

  if (preferredLanguage === SUPPORTED_LANGUAGES.DEFAULT) {
    return languageCode || 'en';
  }
  return preferredLanguage;
};
